"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2443],{

/***/ 72443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgCall = function SvgCall(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M10.088 7.128a1.028 1.028 0 0 0-1.42 0l-.885.886c-.526.103-1.53-.454-2.438-1.36-.905-.906-1.462-1.91-1.36-2.438l.886-.886a1.005 1.005 0 0 0 0-1.42L3.922.963a1.006 1.006 0 0 0-1.42 0l-.948.949C-.32 3.784 1.04 6.849 3.096 8.904c1.37 1.37 3.189 2.43 4.804 2.43a2.992 2.992 0 0 0 2.188-.889l.95-.948a1.004 1.004 0 0 0 0-1.42l-.95-.949Zm.478 1.897-.949.95c-.855.855-1.993.756-2.798.523a7.977 7.977 0 0 1-3.252-2.065 7.98 7.98 0 0 1-2.065-3.252c-.234-.804-.334-1.943.523-2.8l.949-.948a.338.338 0 0 1 .477 0l.949.949a.338.338 0 0 1 0 .477l-.949.949a.333.333 0 0 0-.08.13c-.31.931.573 2.257 1.503 3.187.931.93 2.258 1.812 3.187 1.503a.334.334 0 0 0 .13-.08l.949-.949a.345.345 0 0 1 .477 0l.949.95a.337.337 0 0 1 0 .476Z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "M7 5.332h1.333a.333.333 0 1 0 0-.666h-1v-.667h1a.333.333 0 0 0 .333-.333V2.334A.333.333 0 0 0 8.333 2H7a.333.333 0 0 0 0 .666h1v.666H7a.333.333 0 0 0-.333.333V5A.333.333 0 0 0 7 5.332ZM10.997 2a.333.333 0 0 0-.333.333v1h-.667v-1a.333.333 0 0 0-.666 0v1.333a.333.333 0 0 0 .333.333h1v1a.333.333 0 0 0 .666 0V2.333A.334.334 0 0 0 10.997 2Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgCall);

/***/ })

}]);